module.exports = __webpack_public_path__ + "static/media/bombas-pe-04.cb44f547.jpeg";